import React from 'react'

function AddProperty() {
    return (
        <div>
             <section>
            <div className="add-propert-header">
              <h1>Add Property</h1>
            </div>
          </section>
          <section className="add-propert-form-alignment">
            <div className="cus-forma-control">
              <div className="form-grid">
                <div className="form-grid-items">
                  <div className="cus-forma-control">
                    <label>Property Name</label>
                  </div>
                </div>
                <div className="form-grid-items">
                  <div className="cus-forma-control">
                    <input type="text" placeholder="Wade Williams"/>
                  </div>
                </div>
              </div>
              <div className="form-grid">
                <div className="form-grid-items">
                  <div className="cus-forma-control">
                    <label>Asset Value</label>
                  </div>
                </div>
                <div className="form-grid-items">
                  <div className="cus-forma-control">
                    <input type="text" placeholder="Wade Williams"/>
                  </div>
                </div>
              </div>
              <div className="form-grid">
                <div className="form-grid-items">
                  <div className="cus-forma-control">
                    <label>Ownership Status</label>
                  </div>
                </div>
                <div className="form-grid-items">
                  <div className="cus-forma-control">
                  <select name="cars" id="cars">
                    <option value="Ownership">Ownership</option>
                    <option value="1/4">1/4</option>
                    <option value="2/4">2/4</option>
                    <option value="3/4">3/4</option>
                  </select>
                  </div>
                </div>
              </div>
              <div className="form-grid">
                <div className="form-grid-items">
                  <div className="cus-forma-control">
                    <label>City</label>
                  </div>
                </div>
                <div className="form-grid-items">
                  <div className="cus-forma-control">
                    <input type="text" placeholder="City"/>
                  </div>
                </div>
              </div>
              <div className="form-grid">
                <div className="form-grid-items">
                  <div className="cus-forma-control">
                    <label>State</label>
                  </div>
                </div>
                <div className="form-grid-items">
                  <div className="cus-forma-control">
                    <input type="text" placeholder="State"/>
                  </div>
                </div>
              </div>
              <div className="form-grid">
                <div className="form-grid-items">
                  <div className="cus-forma-control">
                    <label>Location</label>
                  </div>
                </div>
                <div className="form-grid-items">
                  <div className="cus-forma-control">
                    <input type="text" placeholder="Location"/>
                  </div>
                </div>
              </div>
              <div className="form-grid">
                <div className="form-grid-items">
                  <div className="cus-forma-control">
                    <label>Attache Image*</label>
                  </div>
                </div>
                <div className="form-grid-items">
                  <div className="file-box-upload">
                    <div>
                      <input type="file"/>
                    </div>
                    <div>
                      <input type="file"/>
                    </div>
                    <div>
                      <input type="file"/>
                    </div>
                    <div>
                      <input type="file"/>
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-grid">
                <div className="form-grid-items">
                  <div className="cus-forma-control">
                    <label>Description</label>
                  </div>
                </div>
                <div className="form-grid-items">
                  <div className="cus-forma-control">
                    <textarea id="w3review" placeholder="Your description here" name="w3review"></textarea>
                  </div>
                </div>
              </div>
              <div className="form-grid">
                <div className="form-grid-items">
                  <div className="cus-forma-control">
                    <label>Property Features</label>
                  </div>
                </div>
                <div className="form-grid-items">
                  <div className="child-input-alignment">
                    <div>
                      <span>Beds</span>
                      <input type="text" placeholder="00"/>
                    </div>
                    <div>
                      <span>Beds</span>
                      <input type="text" placeholder="00"/>
                    </div>
                    <div>
                      <span>Beds</span>
                      <input type="text" placeholder="00"/>
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-grid">
                <div className="form-grid-items">
                  <div className="cus-forma-control">
                    <label>Distinctive Amenitles</label>
                  </div>
                </div>
                <div className="form-grid-items">
                    <div className="checkbox-grid">
                      <div className="checkbox-grid-items">
                        <div className="sub-grid">
                          <div className="sub-grid-items">
                            <input type="checkbox"/>
                          </div>
                          <div className="sub-grid-items">
                            <div className="cus-form-control">
                              <input type="text" placeholder="Beach Access"/>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="checkbox-grid-items">
                        <div className="sub-grid">
                          <div className="sub-grid-items">
                            <input type="checkbox"/>
                          </div>
                          <div className="sub-grid-items">
                            <div className="cus-form-control">
                              <input type="text" placeholder="Beach Access"/>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="checkbox-grid-items">
                        <div className="sub-grid">
                          <div className="sub-grid-items">
                            <input type="checkbox"/>
                          </div>
                          <div className="sub-grid-items">
                            <div className="cus-form-control">
                              <input type="text" placeholder="Beach Access"/>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="checkbox-grid-items">
                        <div className="sub-grid">
                          <div className="sub-grid-items">
                            <input type="checkbox"/>
                          </div>
                          <div className="sub-grid-items">
                            <div className="cus-form-control">
                              <input type="text" placeholder="Beach Access"/>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="checkbox-grid-items">
                        <div className="sub-grid">
                          <div className="sub-grid-items">
                            <input type="checkbox"/>
                          </div>
                          <div className="sub-grid-items">
                            <div className="cus-form-control">
                              <input type="text" placeholder="Beach Access"/>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="checkbox-grid-items">
                        <div className="sub-grid">
                          <div className="sub-grid-items">
                            <input type="checkbox"/>
                          </div>
                          <div className="sub-grid-items">
                              <span>Select All</span>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
              <div className="form-grid">
                <div className="form-grid-items">
                  <div className="cus-forma-control">
                    <label>Target IRR</label>
                  </div>
                </div>
                <div className="form-grid-items">
                  <div className="cus-forma-control target-irr-width">
                      <input type="text" placeholder="Target IRR"/>
                  </div>
                </div>
              </div>
              <div className="form-grid">
                <div className="form-grid-items">
                  <div className="cus-forma-control">
                    <label>Rental Yield</label>
                  </div>
                </div>
                <div className="form-grid-items">
                  <div className="cus-forma-control target-irr-width">
                      <input type="text" placeholder="Target IRR"/>
                  </div>
                </div>
              </div>
              <div className="form-grid">
                <div className="form-grid-items">
                  <div className="cus-forma-control">
                    <label>Video</label>
                  </div>
                </div>
                <div className="form-grid-items">
                  <div className="cus-forma-control video-width">
                      <input type="file" placeholder="Target IRR"/>
                  </div>
                </div>
              </div>
              <div className="form-grid">
                <div className="form-grid-items">
                  <div className="cus-forma-control">
                    <label>Distinctive Amenitles</label>
                  </div>
                </div>
                <div className="form-grid-items">
                    <div className="checkbox-grid">
                      <div className="checkbox-grid-items">
                        <div className="sub-grid">
                          <div className="sub-grid-items">
                            <input type="checkbox"/>
                          </div>
                          <div className="sub-grid-items">
                            <div className="cus-form-control">
                              <input type="text" placeholder="Time Report"/>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="checkbox-grid-items">
                        <div className="sub-grid">
                          <div className="sub-grid-items">
                            <input type="checkbox"/>
                          </div>
                          <div className="sub-grid-items">
                            <div className="cus-form-control">
                              <input type="text" placeholder="Investment Report"/>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="checkbox-grid-items">
                        <div className="sub-grid">
                          <div className="sub-grid-items">
                            <input type="checkbox"/>
                          </div>
                          <div className="sub-grid-items">
                              <span>Select All</span>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
              <div className="form-grid">
                <div className="form-grid-items">
                  <div className="cus-forma-control">
                  </div>
                </div>
                <div className="form-grid-items">
                    <div className="save-submit-button-alignment">
                    <button>Save</button>
                    <button>Submit</button>
                  </div>
                </div>
              </div>
             
            </div>
          </section>
        </div>
    )
}

export default AddProperty
